import * as PropTypes from 'prop-types';
import { useFela } from 'react-fela';

import { Uploader, fileShape } from 'modules/uploader';

import { imageMapsUploader } from '../../services/config';

import rule from './ImageMapUploader.rule';

const ImageMapUploader = ({ imageMaps }) => {
    const { css } = useFela();
    return (
        <div className={css(rule)}>
            <Uploader name={imageMapsUploader} initialFiles={imageMaps} enableReinitialize />
        </div>
    );
};

ImageMapUploader.propTypes = {
    imageMaps: PropTypes.arrayOf(fileShape),
};

ImageMapUploader.defaultProps = {
    imageMaps: [],
};

export default ImageMapUploader;
